// extracted by mini-css-extract-plugin
export default {"exoticDescription":"dd6Tm","minimalSockets":"_o9kp"};